import { DynamicBlocks, IRenderingBlock } from "@montana/blocks/dynamic-blocks.component";
import { isBrowser } from "@montana/helpers/browser.helper";
import { fragmentEncode } from "@montana/helpers/url-fragment.helper";
import { IColorMaterialDescriptionBlock, IColorMaterialDescriptionPage } from "@montana/models/generated/cms.interface";
import { RichText } from "@montana/shared/rich-text";
import React, { ReactNode, useMemo, useState } from "react";

let incrementingId = 0;
const getNextIncrementingId = () => ++incrementingId;
const BASE_ID = 'color-material-view';
const LINK_CLASS_NAME = 'color-material-view__navigation-link';

export const ColorMaterialView: React.VFC<IColorMaterialDescriptionPage> = (props) => {
    /**
     * Append an auto-incrementing number to the class name, if `BASE_ID` is already used
     * by another element.
     */
    const [selectedNav, setSelectedNav] = useState<string | undefined>(undefined);
    const rootDomId = useMemo(() => {
        return isBrowser && !!document.querySelector(`.${BASE_ID}`)
            ? `${BASE_ID}-${getNextIncrementingId()}`
            : BASE_ID;
    }, []);

    const mappedColorBlocks = useMemo(() => (props.colorBlocks || []).map<IRenderingBlock>((block, index) => {
        const domId = block.kind === 'ColorMaterialDescriptionBlock'
            ? rootDomId + '-' + fragmentEncode((block as IColorMaterialDescriptionBlock).header!)
            : rootDomId + '-' + index;

        const className = index === 0
            ? `${LINK_CLASS_NAME} ${LINK_CLASS_NAME}--first`
            : LINK_CLASS_NAME;

        return {
            ...block,
            className,
            domId,
        }
    }), [rootDomId, props.colorBlocks]);

    return (
        <div className="color-material-view" id={rootDomId}>
            {props.header && <RichText className="color-material-view__heading" text={props.header} />}
            {props.headerDescription && <RichText className="color-material-view__description" text={props.headerDescription} />}
            <ul className="color-material-view__navigation">
                {mappedColorBlocks.reduce((acc, block) => {
                    if (block.kind === 'ColorMaterialDescriptionBlock') {
                        const colorBlock = block as IColorMaterialDescriptionBlock;
                        const blockClassName = !selectedNav 
                            ? block.className 
                            : selectedNav === colorBlock.name 
                            ? `${LINK_CLASS_NAME} ${LINK_CLASS_NAME}--first` 
                            : LINK_CLASS_NAME
                        acc.push(<li
                            className="color-material-view__navigation-item"
                            key={block.domId}
                            onClick={() => {setSelectedNav(colorBlock.name)}}>
                            <a
                                className={blockClassName}
                                href={location.pathname + location.search + '#' + block.domId}>
                                {colorBlock.header}
                            </a>
                        </li>);
                    }

                    return acc;
                }, new Array<ReactNode>())}
            </ul>
            {props.colorHeader && <RichText className="color-material-view__color-heading" text={props.colorHeader} />}
            {props.colorHeaderDescription && <RichText className="color-material-view__color-description" text={props.colorHeaderDescription} />}
            <div className="color-material-view__color-blocks">
                <DynamicBlocks blocks={mappedColorBlocks} />
            </div>
        </div>
    );
}
